module.exports = __webpack_public_path__ + "img/light-dark.3401ae4e.png";